module.exports = __webpack_public_path__ + "static/media/philipp-meeh-Bu-fUI69fRo-unsplash.e01da46f.jpg";